import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, X, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';
export default function Footer() {
  const [logoUrl, setLogoUrl] = useState('/perplexity-new-logo.png');

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const { data, error } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'logo_url')
        .single();

      if (data && !error && data.value) {
        // Test if the image loads before setting it
        const img = new Image();
        img.onload = () => {
          setLogoUrl(data.value);
        };
        img.onerror = () => {
          console.warn('Failed to load custom logo in footer, using default');
        };
        img.src = data.value;
      } else if (error) {
        console.warn('Could not fetch logo from settings for footer:', error.message);
      }
    } catch (err) {
      console.warn('Network error fetching logo for footer:', err);
    }
  };

  return (
    <footer className="bg-black py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img src={logoUrl} alt="Perplexity" className="h-12 w-auto mb-4" />
            <p className="text-gray-400 text-sm">
              A Registered Trademark of Perplexity Solved Solutions Inc
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-2">
              <a href="mailto:info@perplexityonline.com" 
                 className="text-gray-400 hover:text-white flex items-center group">
                <Mail className="w-4 h-4 mr-2 text-primary group-hover:text-white transition-colors" />
                info@perplexityonline.com
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Address</h4>
            <div className="text-gray-400 flex items-start">
              <MapPin className="w-4 h-4 mr-2 mt-1 text-primary" />
              <p>
                Headquarters<br />
                5851 Legacy Cir<br />
                Plano, Texas 75024
              </p>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/perplexityhq/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-linkedin"
              >
                <div className="p-2 rounded-lg bg-gradient-to-br from-[#0077B5] to-[#00A0DC] hover:scale-110 transition-transform">
                  <Linkedin className="w-5 h-5 text-white" />
                </div>
              </a>
              <a 
                href="https://x.com/PerplexityHQ" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-x"
              >
                <div className="p-2 rounded-lg bg-gradient-to-br from-[#000000] to-[#333333] hover:scale-110 transition-transform">
                  <X className="w-5 h-5 text-white" />
                </div>
              </a>
              <a 
                href="https://www.facebook.com/Perplexitymeet/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-icon-facebook"
              >
                <div className="p-2 rounded-lg bg-gradient-to-br from-[#1877F2] to-[#00B2FF] hover:scale-110 transition-transform">
                  <Facebook className="w-5 h-5 text-white" />
                </div>
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              PERPLEXITY™, all rights reserved.
            </p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <Link to="/terms" className="text-[#40E0D0] hover:text-[#0066FF] text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-[#40E0D0] hover:text-[#0066FF] text-sm transition-colors">
                Privacy Statement
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}